<template>
  <div>
    <app-header-container>
      {{ $t('views.Dashboard.Bills.bills') }}

<!--      <template v-slot:controls v-if="screen.breakPoint.tabPort">-->
<!--        <autocomplete not-empty value-field="id" item-text="fullName" v-model="currContractId" :items="contracts" :placeholder="$t('views.Orders.contractSelect.label')"></autocomplete>-->
<!--      </template>-->
    </app-header-container>

<!--    <app-controls-container no-padding>-->
<!--      <div v-if="!screen.breakPoint.tabPort">-->
<!--        <autocomplete not-empty value-field="id" item-text="fullName" v-model="currContractId" :items="contracts" :placeholder="$t('views.Orders.contractSelect.label')"></autocomplete>-->
<!--      </div>-->
<!--    </app-controls-container>-->

    <bills-list date-field="date" :bills="bills ? bills.content : []" :loading="loading" class="reset-indent"></bills-list>
    <list-footer :loading="loadingMore" :total="totalElements"></list-footer>
  </div>
</template>

<script>
import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
// import AppControlsContainer from '@/ui/layout/AppControlsContainer'
// import Autocomplete from '@/ui/controls/Autocomplete'

import ListFooter from '@/ui/slots/List/ListFooter'

import BillsList from '@/components/BillsList'

import { BillsGQL } from '@/graphql/queries'

import hasActiveContracts from '@/mixins/hasActiveContracts'
import fetchMore from '@/mixins/fetchMore'
import contracts from '@/mixins/contracts'
import screen from '@/mixins/screen'

export default {
  mixins: [hasActiveContracts, fetchMore, contracts, screen],

  data () {
    return {
      routeLiving: false,
      refetching: false,
      page: 0,
      size: 15
    }
  },

  components: {
    AppHeaderContainer,

    ListFooter,
    BillsList
  },

  apollo: {
    bills: {
      query: BillsGQL,
      update: data => data.merchant.bills,
      variables () {
        return {
          params: {
            page: this.page,
            size: this.size
            // partnerContractId: this.currContractId
          }
        }
      },
      skip () {
        return !this.hasActiveContracts
      }
    }
  },

  computed: {
    loading () {
      return (!this.bills && true) || (this.$apollo.queries.bills && this.$apollo.queries.bills.loading && !this.fetchingMore)
    },

    loadingMore () {
      return this.bills && this.$apollo.queries.bills && this.$apollo.queries.bills.loading && this.fetchingMore
    },

    totalElements () {
      return this.bills ? this.bills.totalElements : 0
    }
  },
  methods: {
    showMore () {
      const params = {
        page: this.page,
        size: this.size,
        partnerContractId: this.currContractId
      }

      if (this.bills) {
        this.fetchMore({
          params,
          rootField: 'merchant',
          apolloQueryField: 'bills',
          currPage: this.bills.currentPage
        })
      }
    }
  },
  mounted () {
    document.addEventListener('reachedBottom', this.showMore)
  },

  beforeDestroy () {
    document.removeEventListener('reachedBottom', this.showMore)
  }
}
</script>

<style lang="scss">
  .bills {
    &__group {
      &:not(:last-child) {
        margin-bottom: 2rem;
      }
    }
  }
</style>
